export default __webpack_public_path__ + "static/media/resourceTypeImg2.65fe3e3f.png";